import { BaseComponent } from '../base-component'
import { isEnterKey } from '../../utils/key'
import { parseHTML } from '../../utils/dom'
import { PaginationComponent } from './pagination'
import { $elParent } from 'src/scripts/utils/utils'

const PAGINATION_COMPONENT_SELECTOR = 'pagination-component'

export class PaginationLink extends BaseComponent {
  mountComponent(): void {
    this.addListener(this, 'keydown', this.handleKeyDown)
    this.addListener(this, 'click', this.handleLinkClick)
  }

  handleLinkClick = (event: MouseEvent): void => {
    event.preventDefault()
    this.fetchResults()
  }

  handleKeyDown = (event: KeyboardEvent): void => {
    if (isEnterKey(event)) {
      event.preventDefault()
      this.fetchResults()
    }
  }

  fetchResults(): void {
    const pagination: PaginationComponent = $elParent(
      PAGINATION_COMPONENT_SELECTOR,
      this,
    )
    const url = this.dataset.url

    if (pagination && url) {
      this.getFromUrl(url)
    }
  }

  getFromUrl(url: string): void {
    const pagination: PaginationComponent = $elParent(
      PAGINATION_COMPONENT_SELECTOR,
      this,
    )

    if (pagination) {
      pagination.loadingOverlay.classList.remove('hidden')

      fetch(url)
        .then(response => response.text())
        .then(responseText => {
          const html = parseHTML(responseText)

          pagination.loadingOverlay.classList.add('hidden')

          this.updatePaginationFromHTML(html)
        })
        .catch(() => {
          console.log('Error in pagination link component')
        })
    }
  }

  updatePaginationFromHTML(html: Document): void {
    const pagination: PaginationComponent = $elParent(
      PAGINATION_COMPONENT_SELECTOR,
      this,
    )

    if (pagination) {
      pagination.updateResultsFromHTML(html)
      pagination.updateFromHTML(html)
    }
  }
}
